import { atom } from "jotai";

import { locationApi } from "../services";
import { locationForm } from "./form";

/**
 * Mirrors `selectExistingContactAddressAtom`: picking an existing address
 * for the location loads it into the same "new address" fields so it can
 * also be edited (and saved back via `updateAddress` on submit), instead of
 * only being referenced by id.
 */
export const selectExistingLocationAddressAtom = atom(
  null,
  async (_get, set, addressId: number | null) => {
    set(locationForm.fields.addressId.atom, addressId ?? undefined);

    const fields = locationForm.fields.createNewAddress.fields;

    if (addressId == null) {
      set(fields.place.atom, "");
      set(fields.street.atom, "");
      set(fields.extendedAddress.atom, "");
      set(fields.postOfficeBox.atom, "");
      set(fields.postalCode.atom, "");
      set(fields.city.atom, "");
      set(fields.country.atom, "CH");

      return;
    }

    const address = await locationApi.fetchAddress(addressId);

    set(fields.place.atom, address.place ?? "");
    set(fields.street.atom, address.street ?? "");
    set(fields.extendedAddress.atom, address.extendedAddress ?? "");
    set(fields.postOfficeBox.atom, address.postOfficeBox ?? "");
    set(fields.postalCode.atom, address.postalCode ?? "");
    set(fields.city.atom, address.city ?? "");
    set(fields.country.atom, address.country ?? "CH");
  },
);
